<template>
  <section :style="{background: `url(${this.backgroundImage})`}" class="hero is-header is-medium bottom-align" :class="{'is-center': !top, 'is-center-top': top}">
    <div class="category container ">
      <section class="section">
        <h1 class="is-white m-b-5 title" :class="$mq.resize && $mq.above($mv.tablet) ? 'is-2' : 'is-4'"
>{{content}}</h1>
      </section>
    </div>
  </section>
</template>
<script>
  export default{
    props: ['backgroundImage', 'direction', 'content', 'top'],
    watch: {
			'backgroundImage': function(path) {
				if (path !== '#') {
					let url = path;
					
					let loaded = false;
					let img = new Image();
					img.src = url;
					// publish the loading event as a start
					this.$parent.$emit('loading');
					img.onload = () => {
						this.$parent.$emit('loaded');
						loaded = true;
					}
					// if images not loaded after too long, just fire the event regardless 
					setTimeout( () => {
							if (!loaded) {
								this.$parent.$emit('loaded');
							}
					}, 5000 )  
				}
			}
    }
  };
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/vars.scss';
  .wrapper {
    // padding: 2em;
    margin: auto 0;
  }
  h1 {
    text-shadow: 1px 1px 10px black;
    @media (min-width: 770px) {
      width: 70%
    }
    // @media (max-width: 770px) {
    //   font-size: 2.5rem !important;
    // }
  }
  h3 {
    padding-top: 20px;
  }
  .hero {
    width: 100%;
    background-size: cover !important;
    background-repeat:no-repeat !important;
    height: 75vh;
  }
  .is-center {    
    background-position: center center !important;
  }
  .is-center-top {
    background-position: center top !important;
  }
  .bottom-align {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    // padding-bottom: 25px;
  }
  .top-align {
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
</style>


// WEBPACK FOOTER //
// hero.vue?ec88e97a